'use strict';

import { getBlocksOfficeSession, isLoggedIn } from '../utils/cookies';
import { privateGet } from '../utils/m2';

export function getSessionKey() {
    if (!isLoggedIn()) {
        return Promise.resolve(null);
    }

    const sessionKey = getBlocksOfficeSession();

    if (sessionKey) {
        return Promise.resolve(sessionKey);
    }

    return Promise.resolve(null);
}

export function getUserDetails() {
    return getSessionKey().then(sessionKey => {
        if (!sessionKey) {
            return Promise.reject('Invalid session');
        }

        const params = {
            urlParams: {
                sessionKey,
            },
        }

        return privateGet('user-details/{sessionKey}', params).then(response => {
            return response.data;
        });
    }).catch(() => {
        return Promise.reject('Invalid session');
    });
}
